
import Vue from 'vue'
import { selectElementContents } from '~/lib/util/dom_utils';

export default Vue.extend({
  props: {
    text: {
      type: String,
      required: false
    },
    clazz: {
      type: String,
      default: ''
    },
    textBoxClass: {
      type: String,
      default: ''
    },
    textHidden: {
      type: Boolean,
      default: false
    },
    buttonClass: {
      type: String,
      default: ''
    },
    copyText: {
      type: String,
      default: 'Kopiuj'
    }
  },
  data() {
    return {
      copyText_: this.copyText,
      copyTextTimeout: null
    }
  },
  methods: {
    selectText() {
      selectElementContents(this.$refs!.text as HTMLElement);
    },
    async copyToClipboard() {
      navigator.clipboard.writeText(
        // @ts-ignore: TODO
        this.text ? this.text : this.$refs!.text.textContent.trim()
      );

      // @ts-ignore: TODO
      this.copyText_ = 'Skopiowano!';

      // @ts-ignore: TODO
      if(this.copyTextTimeout) {
        // @ts-ignore: TODO
        clearTimeout(this.copyTextTimeout);
      }

      // @ts-ignore: TODO
      this.copyTextTimeout = setTimeout(() => {
        // @ts-ignore: TODO
        this.copyText_ = this.copyText;
      }, 2000);

      // TODO show toast "skopiowano"
    },
  }
})
